import { useMemo, useState } from 'react'
import classNames from 'classnames'
import { ImageAsset } from 'types/common'

import { useOpenState } from '@hooks/open-state'
import { PosterImage } from '@elements/poster-image'
import { ImageModal } from './image-modal'
import { Carousel } from './carousel'

export interface GalleryProps {
  images?: ImageAsset[]
  alt: string
  w: string
  h: string
  loading?: 'lazy' | 'eager'
  className?: string
  imageClassName?: string
}

export function Gallery({
  images,
  alt,
  w,
  h,
  loading = 'lazy',
  className,
  imageClassName,
}: GalleryProps) {
  const imageModal = useOpenState()
  const [imageIndex, setImageIndex] = useState<number | undefined>(undefined)
  const imageModalSources = useMemo(() => images?.map((img) => img.filename), [images])

  return (
    <>
      <Carousel
        className={className}
        itemClassName={classNames('shrink-0 transition-all cursor-pointer', imageClassName)}
      >
        {images?.map((image, index) => (
          <div
            key={image.id}
            onClick={() => {
              setImageIndex(index)
              imageModal.open()
            }}
          >
            <PosterImage
              alt={`${alt}, Image ${index + 1}`}
              src={image.filename}
              loading={loading}
              w={w}
              h={h}
              fill="blur"
              fit="fill"
              dpr=".50"
              fm="webp"
            />
          </div>
        ))}
      </Carousel>
      <ImageModal
        sources={imageModalSources ?? []}
        setSelectedIndex={setImageIndex}
        selectedIndex={imageIndex}
        {...imageModal}
      />
    </>
  )
}
